import { formatDate } from 'devextreme/localization';
import { useContext, } from 'react';
import { Link } from 'react-router-dom';
import { Card, Field } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderInformationCard() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			<Card
				header={'Work Order Information'}
			>
				<Field label={'Work Order #'} >{order.details.woNumber}</Field>
				<Field label={'Status'} >{order.details.orderStatus}</Field>
				<Field label={'WO Date'} >{formatDate(new Date(order.details.woDate), 'shortDate')}</Field>
				<Field label={'Project #'} >{order.details.projectNumber}</Field>
				<Field label={'Originating RO #'} >
					<Link to={'/cfi/retail-order/' + order.details.originatingROID + '?returnUrl=' + encodeURIComponent('/cfi/orders/retail-orders')}>
						{order.details.originatingRO}
					</Link>
				</Field>

			</Card>
		</>
	);
}
